import React from 'react';
import * as XanoApi from '../apis/XanoApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import * as Utils from '../utils';
import {
  ButtonOutline,
  ButtonSolid,
  Row,
  ScreenContainer,
  StarRating,
  withTheme,
} from '@draftbit/ui';
import { Modal, StyleSheet, Text, View } from 'react-native';

const ReflectMotivationScreen = props => {
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();

  const { theme } = props;
  const { navigation } = props;

  const [starRatingValue, setStarRatingValue] = React.useState(0);

  return (
    <ScreenContainer scrollable={false} hasSafeArea={true}>
      <View>
        <Text style={[styles.Texte3364987, { color: theme.colors.strong }]}>
          {'How was your time with your children yesterday?\n'}
        </Text>
      </View>

      <View style={styles.View6f3bcb1e}>
        <Text style={[styles.Textc2499e1c, { color: theme.colors.strong }]}>
          {'Motivation'}
        </Text>

        <Modal
          visible={Constants['Visible']}
          animationType={'slide'}
          presentationStyle={'fullScreen'}
        >
          <Text style={[styles.Texta3db204c, { color: theme.colors.strong }]}>
            {
              '\n\nHow motivated and committed do you feel about maintaining or improving your parenting and your relationship with your child? How committed do you feel about putting in consistent effort to ensure this? How confident do you feel that you are achieving this with your efforts?'
            }
          </Text>
          {/* Close */}
          <ButtonOutline
            onPress={() => {
              try {
                setGlobalVariableValue({
                  key: 'Visible',
                  value: false,
                });
              } catch (err) {
                console.error(err);
              }
            }}
            style={styles.ButtonOutline3975593b}
            title={'Close'}
          />
        </Modal>
        {/* Motivation Rating */}
        <StarRating
          onPress={newMotivationRatingValue => {
            try {
              setGlobalVariableValue({
                key: 'motivation',
                value: newMotivationRatingValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={styles.StarRating02f8ec45}
          starSize={32}
          maxStars={5}
          activeColor={theme.colors.primary}
          inactiveColor={theme.colors.light}
          isEditable={true}
        />
      </View>

      <View style={styles.View2c4fedbd}>
        <Row justifyContent={'space-around'} alignItems={'flex-start'}>
          <ButtonSolid
            onPress={() => {
              try {
                setGlobalVariableValue({
                  key: 'Visible',
                  value: true,
                });
              } catch (err) {
                console.error(err);
              }
            }}
            style={[
              styles.ButtonSolid2d5f6a36,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Info'}
          />
          <ButtonSolid
            onPress={() => {
              const handler = async () => {
                try {
                  await XanoApi.addMetricsPOST(Constants, {
                    connection_var: Constants['connection'],
                    equanimity_var: Constants['equanimity'],
                    motivation_var: Constants['motivation'],
                    patience_var: Constants['patience'],
                    presence_var: Constants['presence'],
                    user_id_var: Constants['user_id'],
                  });
                  Utils.showAlert({
                    title: 'Thanks for your commitment!',
                    message: '',
                    buttonText: '',
                  });
                  navigation.navigate('VisualizationScreen');
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            style={[
              styles.ButtonSolid9f0cb554,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Submit'}
          />
        </Row>
      </View>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  ButtonOutline3975593b: {
    backgroundColor: 'transparent',
    borderRadius: 8,
    borderWidth: 1,
    fontFamily: 'System',
    fontWeight: '700',
    marginTop: 20,
    textAlign: 'center',
  },
  ButtonSolid2d5f6a36: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
  },
  ButtonSolid9f0cb554: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    marginLeft: 20,
    textAlign: 'center',
  },
  StarRating02f8ec45: {
    marginTop: 20,
  },
  Text8189c9ab: {
    marginTop: 20,
    textAlign: 'center',
  },
  Texta3db204c: {
    marginTop: 200,
    textAlign: 'center',
  },
  Textc2499e1c: {
    fontSize: 18,
    textAlign: 'center',
  },
  Texte3364987: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 28,
    marginTop: 40,
    textAlign: 'center',
  },
  View2c4fedbd: {
    alignItems: 'center',
    marginTop: 20,
  },
  View6f3bcb1e: {
    alignItems: 'center',
    marginTop: 150,
  },
});

export default withTheme(ReflectMotivationScreen);
